import React, { useRef, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import moment from "moment-timezone";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { init } from "emoji-mart";
import {
  CloseOutlined,
  UpSquareOutlined,
  DownSquareOutlined,
} from "@ant-design/icons";
import { useQueryClient } from "@tanstack/react-query";
import { Input, Button, Skeleton, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { authLogout } from "services/auth-service/auth.service";
import { cleanupToken } from "services/token-service/token.service";
import {
  cleanupUserData,
  getUserData,
} from "services/user-service/user.service";
import { usePinConversation } from "services/hooks/usePinConversation";

import { useSendMessage } from "../api/conversations";
import ModalDialog from "components/ModalDialog/ModalDialog";
import ImageComponent from "components/ImageComponent/ImageComponent";
import SENDICON from "assets/images/send_icon.svg";
import { ReactComponent as AttchImage } from "assets/images/attachment_icon.svg";
import MessageImage from "./MessageImage";

import "./ConversationView.scss";
import Conversation from "./Conversation";

const { Search } = Input;

const ConversationView = (props) => {
  const navigate = useNavigate();
  const timerRef = useRef();
  const conversationRef = useRef();
  const sendImageModalRef = useRef();
  const userData = getUserData();
  const { convData, token, refetchConversation, prevPath } = props;
  const sendMessageRef = useRef();
  const [elapsedTime, setElapsedTime] = useState(null);
  const [emojiPickerState, setEmojiPicker] = useState(false);
  const [myMessageValue, getMyMessage] = useState("");
  const [seletedImage, setSelectedImage] = useState();
  const [messageArray, setMessageArray] = useState();
  const [messages, setMessages] = useState();
  const [text, setText] = useState("");
  const [searchCount, setSearchCount] = useState("");
  const [itemPosition, setitemPosition] = useState(0);
  const [searchIdArray, setSearchIdArr] = useState();

  const { mutate: sendMessaage } = useSendMessage();
  const queryClient = useQueryClient();

  init({ data });
  const {
    register,
    handleSubmit,
    // reset
    // formState: { errors },
  } = useForm();

  const { mutate: pinConversation } = usePinConversation();

  const renderElapsedTime = () => {
    const startDateTime = new Date(convData?.session_started_at);
    const startStamp = startDateTime.getTime();
    const newDate = new Date();
    const newStamp = newDate.getTime();
    let diff = Math.round((newStamp - startStamp) / 1000);

    const d = Math.floor(diff / (24 * 60 * 60));
    diff = diff - d * 24 * 60 * 60;
    const h = Math.floor(diff / (60 * 60));
    diff = diff - h * 60 * 60;
    const m = Math.floor(diff / 60);
    diff = diff - m * 60;
    const s = diff;

    const time = `${h < 10 ? `0${h}` : h}:${m < 10 ? `0${m}` : m}:${
      s < 10 ? `0${s}` : s
    }`;
    // document.getElementById("time-elapsed").innerHTML = time;
    setElapsedTime(time);
  };

  setInterval(renderElapsedTime, 1000);

  useEffect(() => {
    searchCount &&
      setMessages(
        messages.map((message) => {
          if (message?.body?.includes("</mark>")) {
            setSearchCount();
            return {
              ...message,
              body: message.body.replace(/<[^>]*>/g, ""),
            };
          } else return message;
        })
      );
  }, [text]);

  // let container = document.getElementById("ConversationContainerScroll");
  // console.log(value);
  // let pattern = new RegExp(`${value}`, "gi");

  const onSearch = (value) => {
    // value = value.replace(/[.*+?^${}()|[\]\\]/i, "\\$&");
    // let pattern = new RegExp(`${value}`, "gi");

    setMessages(
      messages.map((message) => {
        if (message?.body?.includes("</mark>")) {
          setSearchCount();
          console.log("id 1 / za brisanje marka");
          return {
            ...message,
            body: message.body.replaceAll(/<[^>]*>/gi, ""),
          };
        } else return message;
      })
    );
    if (value) {
      const messageArr = messages.filter((message) =>
        message?.body.toLowerCase()?.includes(value.toLowerCase())
      );
      setSearchCount(messageArr);
      setSearchIdArr(messageArr?.map((result) => ({ id: result.id })));

      setMessages(
        messages.map((message) => {
          if (message?.body.toLowerCase()?.includes(value.toLowerCase())) {
            const searchWord = new RegExp(value, "gi");
            return {
              ...message,
              body: message.body.replaceAll(searchWord, (matched) => {
                return `<mark id=${message.id}>${matched}</mark>`;
              }),
            };
          } else return message;
        })
      );
    }
  };

  const nextItem = () => {
    if (itemPosition === searchIdArray.length - 1) {
      setitemPosition(0);
    } else {
      setitemPosition(itemPosition + 1);
    }
  };

  const prevItem = () => {
    if (itemPosition === 0) {
      setitemPosition(searchIdArray.length - 1);
    } else {
      setitemPosition(itemPosition - 1);
    }
  };

  useEffect(() => {
    if (searchIdArray) {
      const scroll = document.getElementById(searchIdArray[itemPosition]?.id);
      scroll?.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "start",
      });
    }
  }, [searchIdArray, itemPosition]);

  const logoutSuccess = () => {
    cleanupToken();
    cleanupUserData();
    navigate("/");
    localStorage.clear();
  };

  const logutFailure = (error) => {
    if (error?.response?.status === 401) {
      localStorage.clear();
    }
    navigate("/");
  };
  const handleLogOut = () => {
    authLogout().then(logoutSuccess).catch(logutFailure);
  };

  const pinConvo = (id, data) => {
    const pinData = {
      id,
      attachDetach: data,
    };
    pinConversation(pinData, {
      onSuccess: () => {
        data === "attach"
          ? (convData.attacher_id = userData.id)
          : (convData.attacher_id = "");
      },
    });
  };

  const renderPinCOnvoButton = () => {
    return convData?.attacher_id ? (
      convData.attacher_id === userData.id ? (
        <Button
          type="primary"
          className="PinButton"
          onClick={() => pinConvo(convData.id, "detach")}
        >
          UNPIN CONVO
        </Button>
      ) : (
        <Button type="primary" className="PinButton" disabled>
          PINNED TO OTHER ADMIN
        </Button>
      )
    ) : (
      <Button
        className="PinButton"
        onClick={() => pinConvo(convData.id, "attach")}
      >
        PIN CONVO
      </Button>
    );
  };

  const renderHeader = () => {
    return (
      <div className="HeaderContainer">
        {convData ? <>
        <div className="ElapsedTime">
          <span>Elapsed Time: </span>
          <span ref={timerRef} id="time-elapsed">
            {elapsedTime}
          </span>
        </div>
        <div className="StartDate">
          <span>Start Date:</span>
          <span> {moment(convData?.chat_start_date).format("DD-MM-YYYY")}</span>
        </div>
        <div>
          <span>Total Messages:</span>
          <span> {convData?.total_messages} </span>
        </div>
        <div style={{ position: "relative" }}>
          <Search
            value={text}
            onChange={(e) => {
              setText(e.target.value);
            }}
            placeholder="input search text"
            onSearch={() => onSearch(text)}
            style={{
              width: 200,
            }}
          />
          {searchCount && (
            <div
              style={{
                position: "absolute",
                background: "white",
                padding: "3px",
                right: "30px",
                fontSize: "16px",
                zIndex: 2,
              }}
            >
              <span style={{ marginRight: "2px" }}>{searchCount.length}</span>
              <UpSquareOutlined
                style={{ cursor: "pointer" }}
                onClick={() => nextItem()}
              />
              <DownSquareOutlined
                style={{ cursor: "pointer" }}
                onClick={() => prevItem()}
              />
            </div>
          )}
        </div>
        <div>
          {userData?.roles[0].name === "chat-admin" && renderPinCOnvoButton()}
        </div>
        <div>
          <Button className="LogoutButton" onClick={handleLogOut}>
            Logout
          </Button>
        </div> 
        </> : 
        <Space>
          <Skeleton.Input active={false} size="default" />
          <Skeleton.Input active={false} size="default" />
          <Skeleton.Input active={false} size="default" />
          <Skeleton.Input active={false} size="default" />
          <Skeleton.Button active={false} size="default" shape="default" block={false} />
          <Skeleton.Button active={false} size="default" shape="default" block={false} />
        </Space>}
      </div>
    );
  };

  const sendMessage = () => {
    const sendData = seletedImage
      ? {
          sender_profile_id: convData.fictitious_profile.id,
          receiver_profile_id: convData.user_profile.id,
          body: myMessageValue,
          attachments: [seletedImage],
        }
      : {
          sender_profile_id: convData.fictitious_profile.id,
          receiver_profile_id: convData.user_profile.id,
          body: myMessageValue,
        };
    sendMessaage(
      { sendData, token },
      {
        onSuccess: () => {
          userData?.roles[0].name === "agent"
            ? refetchConversation()
            : navigate(-1);
          queryClient.removeQueries("messageImage", { exact: true });
        },
      }
    );
  };

  const triggerPicker = () => {
    setEmojiPicker(!emojiPickerState);
  };

  const selectEmoji = (emoji) => {
    console.log("emoji ==> ", emoji);
    getMyMessage(
      myMessageValue ? myMessageValue + emoji.native : "" + emoji.native
    );
    setEmojiPicker(!emojiPickerState);
  };

  const outsideClick = () => {
    console.log("outside");
    console.log("emojiPickerState ==> ", emojiPickerState);
  };

  let emojiPicker;
  if (emojiPickerState) {
    emojiPicker = (
      <Picker
        title="Pick your emoji…"
        emoji="point_up"
        data={data}
        theme="light"
        onEmojiSelect={(emoji) => selectEmoji(emoji)}
        onClickOutside={outsideClick}
        style={{ position: "absolute", bottom: "20px", left: "70px" }}
      />
    );
  }

  const handleChange = (e) => {
    const strings = /^\D{0,}\d{0,2}(\.\d{0,0})?\D{0,}$/;
    if (strings.test(e.target.value)) {
      getMyMessage(e.target.value);
    }
  };

  const myMessage = (e) => {
    const keyCode = Object.prototype.hasOwnProperty.call(e, "which")
      ? e.which
      : e.keyCode;
    if (keyCode !== 13) {
      getMyMessage(e.target.value);
    } else {
      e.preventDefault();
      sendMessageRef.current.click();
    }
  };

  const closeModal = (ref) => {
    ref.current.closeModal();
  };

  const openModal = (ref) => {
    ref.current.openModal();
  };

  const renderEditor = () => {
    return (
      <div className="MessageEditor">
        <form onSubmit={handleSubmit(sendMessage)}>
          {seletedImage && (
            <div className="ImagePreview">
              <CloseOutlined
                className="RemoveImage"
                onClick={() => setSelectedImage()}
              />
              <img src={seletedImage} alt={seletedImage} />
            </div>
          )}
          <div className="MessageInputContainer">
            <textarea
              autoFocus={false}
              name="body"
              {...register("body")}
              onKeyDown={myMessage}
              value={myMessageValue}
              onChange={handleChange}
              placeholder="Type your message"
              className="TextArea"
            />
          </div>
          <div className="ButtonsContainer">
            <input type="submit" ref={sendMessageRef} hidden />
            <div className="AttachemntContainer">
              <AttchImage
                className="AttachmentIcon"
                onClick={() => openModal(sendImageModalRef)}
              />
              <em-emoji
                className="EmojiIcon"
                id="grinning"
                skin="2"
                size={20}
                onClick={triggerPicker}
              ></em-emoji>
              {emojiPicker}
            </div>
            <div className="SendButtonContainer">
              <ImageComponent
                url={SENDICON}
                onClick={() => {
                  sendMessageRef.current.click();
                }}
              />
            </div>
          </div>
        </form>
      </div>
    );
  };

  return (
    <div className="ConversationView">
      {renderHeader()}
      <Conversation
        convData={convData}
        token={token}
        conversationRef={conversationRef}
        setMessageArray={setMessageArray}
        messageArray={messageArray}
        messages={messages}
        setMessages={setMessages}
      />
      {userData?.roles[0].name === "chat-admin"
        ? prevPath !== "/mainView/archive"
          ? prevPath !== "/mainView/past-chat"
            ? prevPath !== ""
              ? renderEditor()
              : ""
            : ""
          : ""
        : renderEditor()}
      <ModalDialog ref={sendImageModalRef}>
        <MessageImage
          convData={convData}
          token={token}
          setSelectedImage={setSelectedImage}
          closeModal={closeModal}
          modalRef={sendImageModalRef}
        />
      </ModalDialog>
    </div>
  );
};

export default ConversationView;
